<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-container
          v-scroll="verificarPosicionY"
          :pa-0="$vuetify.breakpoint.lgAndDown"
          class="py-0"
        >
          <!-- <v-card class="elevation-15 pa-5"> -->
          <Head />
          <br />
          <Menu />

          <v-content class="app_central">
            <v-container
              grid-list-lg
              text-xs-center
              :pa-0="$vuetify.breakpoint.mdAndDown"
            >
              <v-snackbar
                v-model="snackbar"
                multi-line
                right
                bottom
                :color="errorColor"
                >{{ error }}</v-snackbar
              >
              <v-slide-x-transition>
                <router-view></router-view>
              </v-slide-x-transition>
            </v-container>
          </v-content>
          <v-fab-transition>
            <v-btn
              v-show="boton_top"
              dark
              fab
              fixed
              bottom
              right
              color="primary lighten-4"
              @click="regresarPosicion(0)"
              small
            >
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
          </v-fab-transition>

          <Footer />
          <!--  </v-card>  -->
        </v-container>
      </v-content>
      <v-dialog v-model="comunicado_tres" width="900px" persistent>
        <v-card class>
         <v-card-title class="headline py-0 my-2 mx-0 px-0">
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="pa-4 ma-0.5" >
              <v-img
                      :src="require('@/assets/comunicadoSuspencionServiciosCI.jpg')"
                      aspect-ratio="1.6"
                      contain
                      ></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn color="#33A2FF"
              flat
              @click="comunicado_tres = false">
              <v-icon class="pr-1">close</v-icon> Cerrar
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>

      <v-dialog v-model="comunicado_dos" width="900px" persistent>
        <v-card class>
          <v-card-title class="headline py-0 my-3 mx-0 px-0">
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="pa-1 ma-0.5" >
            <v-carousel
              hide-delimiters
              cycle
              show-arrows
              height="100%"
              :interval="5000"
            >
              <v-carousel-item
                v-for="(img, i) in publicaciones"
                :key="i"
                cover
              >
                <v-img
                  v-if="img.type == 'image'"
                  :src="require(`@/assets/${img.file}`)"
                  aspect-ratio="1.4"
                  contain
                  ></v-img>
                <iframe v-else :src="`${$apiUrl}/files/${img.file}`" width="100%" height="100%"></iframe>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn color="#33A2FF"
              flat
              @click="comunicado_dos = false">
              <v-icon class="pr-1">close</v-icon> Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <v-btn
        v-if="whatsapp"
        fixed
        dark
        fab
        bottom
        right
        class="button-whatsapp"
        @click="openChat"
      >
        <img :src="require('@/assets/whatsapp-logo.png')" width="35px" />
      </v-btn>
      <app-confirm />
    </v-app>
  </div>

</template>
<script>
import Head from "@/components/Head";
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";
import { mapState } from "vuex";
import AppConfirm from "@/common/plugins/Modal/Confirm.vue";
export default {
  name: "app",
  components: {
    Head,
    Menu,
    Footer,
    AppConfirm
  },
  data() {
    return {
      comunicado_tres: false,
      comunicado: false,
      comunicado_dos: false,
      whatsapp:  this.$store.state.urlWhatsapp,
      boton_top:false,
      snackbar:false,
      publicaciones: [
        {
          file: 'aranceles-minimos-rpa.jpeg',
          type: 'image'
        },
        {
          file: 'linea_800.png',
          type: 'image'
        }
        // {
        //   file: 'curso_garantias.png',
        //   type: 'image'
        // },
        // {
        //   file: 'curso_transparencia.png',
        //   type: 'image'
        // },
        // {
        //   file: 'NOMINA_DE_VOCALES_0001.pdf',
        //   type: 'pdf'
        // }
      ]
    };
  },
  mounted: function() {
    this.obtenerDatosIniciales();
    setTimeout(()=>{
      if(!['CredencialDigital','PoliticaPrivacidad','CertificadoFuncionamiento'].includes(this.$route.name)){
        this.comunicado_dos = true
      }
    },100)
     setTimeout(()=>{
       this.inicializarChat()
     },1000)
  },
  computed:{
    ...mapState(['error','errorColor'])
  },
  watch: {
    error(value) {
      if (value) {
        this.snackbar = true;
      }
    },
    snackbar(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  },
  methods: {
    obtenerDatosIniciales() {
      if (
        this.$store.state.noticias == null ||
        this.$store.state.normativas == null ||
        this.$store.state.cursos == null ||
        this.$store.state.juramentos == null
      ) {
        this.$http
          .get(`${this.$apiUrl}publico/pagina`)
          .then(response => {
            this.$store.commit("setNoticias", response.data.data.noticia);
            this.$store.commit("setNormativas", response.data.data.normativa);
            this.$store.commit("setCursos", response.data.data.curso);
            this.$store.commit("setJuramentos", response.data.data.juramento);
            this.$store.commit("setUrlWhatsapp", response.data.data.urlWhatsapp);
            this.whatsapp = response.data.data.urlWhatsapp
            this.$store.commit(
              "setCredenciales",
              response.data.data.credencial
            );
            this.$store.commit("setOficinas", response.data.data.oficinas);
            this.$http.get(`${this.$apiUrl}publico/cantidad`).then(response => {
              this.$store.commit(
                "setCantidadMatriculacion",
                response.data.data.matriculados
              );
              this.$store.commit(
                "setCantidadRuanna",
                response.data.data.ruanna
              );
              this.$store.commit(
                "setCantidadCiudadania",
                response.data.data.ciudadaniaDigital
              );
            });
          })
          .catch(error => {
            this.$store.commit("setErrorColor", "error");
            this.$store.commit(
              "setError",
              "La página tiene errores vuelva a intentarlo mas tarde"
            );
            if (error.response) {
              if (error.response.status == 404) {
                this.$store.commit(
                  "setError",
                  "Error en la peticion al servidor"
                );
              }
            }
          });
      }
    },
    verificarPosicionY(event) {
      if (window.scrollY > 170) {
        this.boton_top = true;
        this.$store.commit("setMenuFixed", true);
      } else {
        this.$store.commit("setMenuFixed", false);
        this.boton_top = false;
      }
    },
    regresarPosicion(value) {
      this.$vuetify.goTo(0);
    },

    accionComunicado() {
      window.open(
        "https://procurement-notices.undp.org/view_negotiation.cfm?nego_id=10486",
        "_blank"
      );
    },
    accionComunicado_dos() {
      window.open(
        "https://procurement-notices.undp.org/view_negotiation.cfm?nego_id=9405",
        "_blank"
      );
    },
    accionComunicado_tres() {
      window.open(
        "https://procurement-notices.undp.org/view_negotiation.cfm?nego_id=9405",
        "_blank"
      );
    },
    openChat(){
      window.open(this.whatsapp)
      // window.open('https://wa.me/59171521522?text=tengo consulta sobre un tramite que brinda el rpa')
    },
    inicializarChat(){
      // Agregar el archivo CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `${process.env.CHAT_URL}/client/chatbot.css`;
      document.head.appendChild(link);

      // Agregar el archivo JS
      const script = document.createElement('script');
      script.src = `${process.env.CHAT_URL}/client/chatbot.js`;
      script.async = true; // Opcional, para cargar de manera asincrónica
      document.body.appendChild(script);
    }
  }
};
</script>
<style>
.v-content__wrap {
  /* background-color: rgba(0,0,0,0.06) !important;*/
}
.app_central {
  background-image: url("./assets/background.png") !important;
  background-repeat: repeat;
  background-size: 50% !important;
}
.border {
  border-left: 8px solid #402d34 !important;
}
.border-primary {
  border-left: 8px solid #534f7f !important;
}

.button-whatsapp{
  top: 84vh !important;
  right: 25px !important;
  background-color: #00e676 !important;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
	0% {
		/* transform: scale(0.95); */
		box-shadow: 0 0 0 0 rgba(23, 197, 125, 0.7);
	}

	70% {
		/* transform: scale(1); */
		box-shadow: 0 0 0 13px rgba(0, 0, 0, 0);
	}

	100% {
		/* transform: scale(0.95); */
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
}

.baner-development{
    float: right;
    top: -9em;
    right: -10em;
    padding: 10px 20px;
    color: white;
    letter-spacing: 2px;
    background: orangered;
    position: absolute;
    text-align: center;
    transform: rotate(45deg);
    width: 320px;
    z-index: 999999999;
}
.baner-development.fixed{
    top: 5em !important;
    right: -4em !important;
}
.v-carousel__next button, .v-carousel__prev button{
  background-color: rgba(126, 126, 126, 0.35) !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue